import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

interface AuthState {
  accessToken: string;
  setAccessToken: (token: string) => void;

  refreshToken: string;
  setRefreshToken: (token: string) => void;

  currentUser: API.CurrentUser | null;
  setCurrentUser: (user: API.CurrentUser | null) => void;

  currentProject: API.Project | null;
  setCurrentProject: (project: API.Project | null) => void;

  settings: any;
  setSettings: (settings: any) => void;
}

// 防止脏数据导致解析报错，白屏
function safeParse<T>(raw: string | null): T | null {
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

const initialAccessToken = localStorage.getItem('access_token') || '';
const initialRefreshToken = localStorage.getItem('refresh_token') || '';
const initialCurrentUser: API.CurrentUser | null = safeParse(
  localStorage.getItem('current_user') || 'null',
);
const initialCurrentProject: API.Project | null = safeParse(
  localStorage.getItem('current_project') || 'null',
);

export const useAuthStore = create<AuthState>()(
  subscribeWithSelector((set) => ({
    accessToken: initialAccessToken,
    setAccessToken: (token) => set({ accessToken: token }),

    refreshToken: initialRefreshToken,
    setRefreshToken: (token) => set({ refreshToken: token }),

    currentUser: initialCurrentUser,
    setCurrentUser: (user) => set({ currentUser: user }),

    currentProject: initialCurrentProject,
    setCurrentProject: (project) => set({ currentProject: project }),

    settings: {
      navTheme: 'light',
      colorPrimary: '#1890ff',
      layout: 'mix',
      contentWidth: 'Fluid',
      fixedHeader: false,
      fixSiderbar: true,
      colorWeak: false,
      title: 'AsPiCe 开发系统',
      pwa: true,
      logo: '/logo.png',
      iconfontUrl: '',
      waterMarkProps: undefined,
    },
    setSettings: (settings) => set({ settings }),
  })),
);

useAuthStore.subscribe(
  (state) => state.accessToken,
  (value) =>
    value ? localStorage.setItem('access_token', value) : localStorage.removeItem('access_token'),
);

useAuthStore.subscribe(
  (state) => state.refreshToken,
  (value) =>
    value ? localStorage.setItem('refresh_token', value) : localStorage.removeItem('refresh_token'),
);

useAuthStore.subscribe(
  (state) => state.currentUser,
  (value) =>
    value
      ? localStorage.setItem('current_user', JSON.stringify(value))
      : localStorage.removeItem('current_user'),
);

useAuthStore.subscribe(
  (state) => state.currentProject,
  (value) =>
    value
      ? localStorage.setItem('current_project', JSON.stringify(value))
      : localStorage.removeItem('current_project'),
);
